import { css } from '@emotion/react';

import { NewIconsSet } from 'src/utils/constants/IconsConstants';

import { colors } from '../../../../styles/colors';
import {
  getNewIcons,
  SetFontSize,
  ZeeFontMedium
} from '../../../../styles/font';

export const shareButton = css`
  display: flex;
  align-items: center;
  cursor: pointer;
  background: ${colors.white};
  border-radius: 4px;
  padding: 5px 10px;
  color: ${colors.Gray4F};
  ${ZeeFontMedium(11)}
  z-index:1;
  transition: background-color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  &:hover {
    color: ${colors.Purple};
    border-color: ${colors.Purple};
    transition: background-color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  }
`;

export const shareIcon = css`
  ${SetFontSize(15)}
  margin-right: 3px;
  display: flex;
  ${getNewIcons(NewIconsSet.SHARE)}
  &:before {
    content: '%';
  }
`;

export const watchButton = css`
  display: flex;
  align-items: center;
  cursor: pointer;
  background: ${colors.white};
  border: 1px solid ${colors.Gray4F};
  border-radius: 4px;
  padding: 5px 10px;
  z-index: 100;
  ${ZeeFontMedium(11)}
  color:${colors.Gray4F};
  transition: background-color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  &:hover {
    background-color: ${colors.Purple};
    border-color: ${colors.Purple};
    color: ${colors.white};
    transition: background-color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
    &:before {
      border-left-color: #fff;
      transition: border-color 0.25s ease-in,
        bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
    }
  }
  &:before {
    border-bottom: 5px solid transparent;
    border-left: 7px solid #4f4f4f;
    border-top: 5px solid transparent;
    content: '';
    display: block;
    height: 0;
    margin: 0 4px 0 0;
    padding: 0;
    transition: border-color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
    width: 0;
  }
`;

export const container = css`
  display: flex;
`;
